import React, { FC, useCallback } from 'react';
import { OnLinkClickType, S4AMastheadProvider } from '@spotify-internal/s4x-masthead';

import { SUPPORT_SITE_CLIENT_ID } from 'utils/config';
import { sendCounterMetric, Whats } from 'utils/metrics';

import { useTranslation } from './translations/TranslationProvider';
import { TranslationStrings } from './translations/getTranslations';

const S4AMastheadProviderWrapper: FC = ({ children }) => {
  const { t } = useTranslation();
  const getTranslation = useCallback((tKey: any) => t(tKey as keyof TranslationStrings), [t]);

  const onS4ALinkClick = useCallback(({ trackingAttributes }: OnLinkClickType) => {
    // trackingAttributes is usually a tuple of ["Page Context", "Click Context"]
    const actionContext = trackingAttributes[1].toLowerCase().replace(/\s/g, '_');
    sendCounterMetric(Whats.S4X_MASTHEAD, {
      clicked: actionContext,
    });
  }, []);

  return (
    <S4AMastheadProvider
      trackCat="Turnkey Support Site"
      getTranslation={getTranslation}
      clientId={SUPPORT_SITE_CLIENT_ID}
      onLinkClick={onS4ALinkClick}
    >
      {children}
    </S4AMastheadProvider>
  );
};

export default S4AMastheadProviderWrapper;
